import React from "react";
import Icon from "./Icon";

export type AdminStatusTone = "success" | "danger" | "warning" | "neutral";

const TONE_COLORS: Record<AdminStatusTone, { bg: string; fg: string }> = {
  success: { bg: "#e8f5e9", fg: "#2e7d32" },
  danger: { bg: "#ffebee", fg: "#c62828" },
  warning: { bg: "#fff3e0", fg: "#e65100" },
  neutral: { bg: "#f5f5f5", fg: "#666" },
};

interface AdminStatusPillProps {
  label: string;
  tone?: AdminStatusTone;
  iconType?: string;
  iconName?: string;
  iconSize?: number;
  showDot?: boolean;
  dotColor?: string;
}

/**
 * Consistent status pill used across admin screens.
 * Semantic colors: success green, danger red, warning amber, neutral grey.
 */
const AdminStatusPill: React.FC<AdminStatusPillProps> = ({
  label,
  tone = "neutral",
  iconType,
  iconName,
  iconSize = 12,
  showDot = false,
  dotColor,
}) => {
  const { bg, fg } = TONE_COLORS[tone];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-[10px] px-2 py-1 text-[11px] font-semibold whitespace-nowrap"
      style={{ backgroundColor: bg, color: fg }}
    >
      {showDot && (
        <span
          className="h-1.5 w-1.5 shrink-0 rounded-full"
          style={{ backgroundColor: dotColor || fg }}
        />
      )}
      {iconType && iconName && (
        <Icon iconType={iconType} name={iconName} size={iconSize} color={fg} />
      )}
      {label}
    </span>
  );
};

export default AdminStatusPill;
